import type { AccoDetails } from '@/scopes/products/domain/types'
import type { AccoDetailsAPIResponse } from './types'
import { parseSitecoreFloat } from '@/scopes/products/domain/utils'

export interface AccoDetailsResponseMapper {
  map: (data: AccoDetailsAPIResponse) => Omit<AccoDetails, 'locations'>
}

export function createAccoDetailsResponseMapper(): AccoDetailsResponseMapper {
  function map(data: AccoDetailsAPIResponse): Omit<AccoDetails, 'locations'> {
    return {
      breadcrumbs: data.breadcrumbs.map(bc => bc.text),
      imageUrl: data.image.resolvedSrc.split('?')[0],
      name: data.titleText,
      rating: parseSitecoreFloat(data.rating),
      url: data.titleUrl,
      userRating: data.grade?.length ? parseSitecoreFloat(data.grade) : 0,
    }
  }

  return { map }
}
